export default "__VITE_ASSET__BilGPXrD__"